export const bundesligatrainerinnenSymposiumJuli2026 = {
  "id": "bundesligatrainerinnen-symposium-juli-2026",
  "title": "Rugby-Bundesligatrainer*innen-Symposium 2026: Alignment und Praxisumsetzung im Fokus",
  "slug": "bundesligatrainerinnen-symposium-juli-2026",
  "publishedAt": "2026-06-20T09:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "3 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "RBA",
    "Trainersymposium",
    "Trainerbildung",
    "Alignment"
  ],
  "excerpt": "Am 10. und 11. Juli 2026 findet das nächste Rugby-Bundesligatrainer*innen-Symposium statt. Die Veranstaltung verbindet ein digitales Austauschformat mit einer praxisorientierten Präsenzveranstaltung und richtet sich an Trainer*innen im deutschen Leistungs- und Bundesligarugby der Männer und Frauen.",
  "img": "/images/bundesligatrainerinnen-symposium-juli-2026.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Am 10. und 11. Juli 2026 findet das nächste Rugby-Bundesligatrainer*innen-Symposium statt. Die Veranstaltung verbindet ein digitales Austauschformat mit einer praxisorientierten Präsenzveranstaltung und richtet sich an Trainer*innen im deutschen Leistungs- und Bundesligarugby der Männer und Frauen."
    },
    {
      "type": "paragraph",
      "content": "Im Mittelpunkt des Symposiums steht die Vorstellung des entwickelten Alignments sowie dessen konkrete praktische Umsetzung im Trainings- und Spielalltag. Ziel der Veranstaltung ist es, gemeinsame inhaltliche Leitlinien zu vermitteln, den Austausch unter Trainer*innen zu stärken und praxisnahe Impulse für die tägliche Arbeit im Leistungsrugby zu geben."
    },
    {
      "type": "paragraph",
      "content": "Als Referenten werden Curtis Bradford (Bundestrainer 7er Frauen) sowie Michael Poppmeier (Nationaltrainer XV Herren) durch die Veranstaltung führen. Beide waren maßgeblich an der Entwicklung des Alignments beteiligt und werden Einblicke in die inhaltliche Ausrichtung sowie deren praktische Umsetzung geben."
    },
    {
      "type": "paragraph",
      "content": "Der erste Teil des Symposiums findet am Freitag, den 10. Juli 2026, von 18:00 bis 20:00 Uhr als Onlineveranstaltung statt. Thematisiert werden die Grundlagen und Zielsetzungen des Alignments sowie Austausch- und Fragerunden."
    },
    {
      "type": "paragraph",
      "content": "Am Samstag, den 11. Juli 2026, folgt von 11:00 bis 17:00 Uhr die Präsenzveranstaltung beim SC 1880 Frankfurt. Dort steht die praktische Umsetzung auf dem Platz im Mittelpunkt. Geplant sind praxisnahe Coachingformate, Demonstrationen sowie gemeinsame Analyse- und Austauschphasen. Die Teilnehmer*innenzahl ist auf maximal 20 Personen begrenzt."
    },
    {
      "type": "paragraph",
      "content": "Beide Veranstaltungsteile können auch unabhängig voneinander gebucht werden."
    },
    {
      "type": "paragraph",
      "content": "Für die Präsenzveranstaltung wird ein Teilnahmebeitrag von 10 Euro erhoben."
    },
    {
      "type": "paragraph",
      "content": "Die Veranstaltung wird mit insgesamt 8 Lerneinheiten (LE) anerkannt:"
    },
    {
      "type": "list",
      "items": [
        "Freitag (Online): 2 LE",
        "Samstag (Präsenz): 6 LE"
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Die Anmeldung erfolgt verbindlich per E-Mail an:"
    },
    {
      "type": "list",
      "items": [
        { "content": "coachingbl@rugbydeutschland.org", "url": "mailto:coachingbl@rugbydeutschland.org" }
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Mit dem Symposium setzt der Rugby-Bundesligaausschuss seinen Fokus auf Trainer*innenbildung, Wissenstransfer und die nachhaltige Weiterentwicklung gemeinsamer Spiel- und Ausbildungsprinzipien im deutschen Rugby fort."
    }
  ]
};
